module.exports = __webpack_public_path__ + "static/media/Cbse2022.6c5c5cb4.jpeg";